import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-offwhite">
      <h1 className="text-6xl font-bold text-redburnt mb-4">404</h1>
      <p className="text-lg mb-6">Page Not Found</p>
      <Link
        to="/"
        className="px-6 py-3 bg-primary text-offwhite rounded hover:bg-tan transition"
      >
        Go Home
      </Link>
    </div>
  );
};

export default NotFound;
